import React from 'react'
import { LoadingWorkspaceSidebarLayout } from 'modules/workspace/components/WorkspaceSidebarLayout'

export const WorkspaceSidebarLoadingPage = () => (
  <LoadingWorkspaceSidebarLayout />
)
